const translations = {
    client: 'Client',
    clientIsRequired: 'Client is required'
};

export default translations;
